export default __webpack_public_path__ + "static/media/YanoneKaffeesatz-Medium.a5a661cc.ttf";